var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxWidgetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.844,
    viewBox: "0 0 24 23.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13832",
    d: "M82.892 23.6h7.272a1.691 1.691 0 0 0 1.691-1.691v-7.276a1.691 1.691 0 0 0-1.691-1.691h-7.272a1.691 1.691 0 0 0-1.692 1.691v7.272a1.691 1.691 0 0 0 1.692 1.695zm0-8.964h7.272v7.272h-7.272z",
    style: {
      fill: "#333"
    },
    transform: "translate(-81.201 -12.942)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13833",
    d: "M133.52 79.558 131 82.1l-1.015-1.019a.846.846 0 1 0-1.2 1.193l1.438 1.443a1.087 1.087 0 0 0 .776.322 1.085 1.085 0 0 0 .776-.323l2.945-2.965a.845.845 0 1 0-1.2-1.191z",
    transform: "translate(-126.424 -76.345)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13834",
    d: "M375.506 151.61h-9.638a.845.845 0 1 0 0 1.691h9.638a.845.845 0 1 0 0-1.691z",
    transform: "translate(-352.351 -145.419)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13835",
    d: "M375.506 72.066h-9.638a.845.845 0 1 0 0 1.691h9.638a.845.845 0 1 0 0-1.691z",
    transform: "translate(-352.351 -69.427)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13836",
    d: "M82.892 319.043h7.272a1.691 1.691 0 0 0 1.691-1.691v-7.272a1.691 1.691 0 0 0-1.691-1.691h-7.272a1.691 1.691 0 0 0-1.691 1.691v7.272a1.691 1.691 0 0 0 1.691 1.691zm0-8.964h7.272v7.272h-7.272z",
    transform: "translate(-81.201 -295.198)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13837",
    d: "m133.52 375-2.52 2.542-1.015-1.019a.846.846 0 1 0-1.2 1.193l1.438 1.443a1.087 1.087 0 0 0 .776.322 1.086 1.086 0 0 0 .776-.323l2.945-2.965a.845.845 0 1 0-1.2-1.191z",
    transform: "translate(-126.424 -358.6)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13838",
    d: "M375.506 447.06h-9.638a.845.845 0 0 0 0 1.691h9.638a.845.845 0 0 0 0-1.691z",
    transform: "translate(-352.351 -427.68)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13839",
    d: "M375.506 367.52h-9.638a.845.845 0 1 0 0 1.691h9.638a.845.845 0 1 0 0-1.691z",
    transform: "translate(-352.351 -351.691)",
    style: {
      fill: "#333"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxWidgetIcon);
export default __webpack_public_path__ + "static/media/checkbox-widget-icon.55f90e86e7c46ede5052974d596c924c.svg";
export { ForwardRef as ReactComponent };